<template lang="pug">
.container.grid-xl
  page-title(icon="fas fa-file-alt" title="Termos de uso" subtitle="Termos de uso do Acervo")
    button.btn.btn-primary(slot="actions" @click="onSubmit" :disabled="disabled") Salvar
  .flex-centered.full-height(v-if="error") #[error-box(:error="error")]
  fieldset(v-else :disabled="loading")
    form(@submit.prevent="onSubmit")
      .columns
        .column.col-12
          .form-group
            .form-label Idioma
            select.form-select(v-model="usageTerm.language")
              option(v-for="language, key in mapLanguage" :value="key") {{language}}
        .column.col-12
          .form-group
            .form-label Termo
            vue-editor.editor(v-model.trim="usageTerm.term" :editorToolbar="editorToolbar")
</template>

<script>
import usageTermsServices from '@/services/usageTerms'
import { deepClone } from 'paliari-js-utils'
import { mapLanguage } from '@/lib/constants'

export default {
  data() {
    return {
      usageTerm: {
        term: '',
        language: 'pt',
      },
      loading: false,
      error: null,
      mapLanguage,
    }
  },

  computed: {
    disabled() {
      const { term } = this.usageTerm
      return this.loading || !term || term.length > 65535
    },

    creatingNewEntry() {
      return Boolean(!this.$route.params.id)
    },

    editorToolbar() {
      return [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
      ]
    },
  },

  methods: {
    async onSubmit() {
      try {
        this.loading = true
        const entryFunction = this.creatingNewEntry
          ? this.createNewEntry
          : this.updateEntry
        await entryFunction()
        this.$toaster.success('Termo salvo com sucesso')
      } catch (e) {
        this.$toaster.error('Erro ao salvar termos de uso')
      } finally {
        this.loading = false
      }
    },

    async createNewEntry() {
      await usageTermsServices.create(this.usageTerm)
    },

    async updateEntry() {
      await usageTermsServices.update(this.usageTerm)
    },
  },

  async created() {
    if (!this.creatingNewEntry) {
      try {
        this.loading = true
        const { data } = await usageTermsServices.show(this.$route.params.id)
        this.usageTerm = deepClone(data)
      } catch (e) {
        this.$toaster.error('Falha ao recuperar o termo de uso')
        this.error = e
      } finally {
        this.loading = false
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
.editor
  height 500px
</style>
